import tokens from './tokens'
import mask from './directive'
import TheMask from './component.vue'

function install (Vue) {
  Vue.component(TheMask.name, TheMask)
  Vue.directive('mask', mask)
}

const version = '1.0.0'

export {
  TheMask,
  mask,
  tokens,
  version
}

// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}



// WEBPACK FOOTER //
// ./src/components/utils/vue-the-mask/index.js